/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts from 'highcharts';
import { merge, cloneDeep } from 'lodash';
import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  Button,
  CircularProgress
} from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { barChartBase } from './utils/barChartBase';

const scrollableMinHeight = shippedItemsQuantities => {
  if (shippedItemsQuantities.length >= 100) {
    return 4000;
  }
  return shippedItemsQuantities.length * 40;
};

const ShippedItemsPackageDialog = ({
  shippedQuantitiesByCarrier,
  open,
  handleClose,
  loadingShippedQuantitiesByCarrier
}) => {
  const totalShipped = shippedQuantitiesByCarrier.reduce(
    (a, b) => +a + +b.quantity,
    0
  );

  const override = {
    chart: {
      scrollablePlotArea: {
        minHeight: scrollableMinHeight(shippedQuantitiesByCarrier),
        opacity: 0.6
      },
      marginRight: 30
    },
    xAxis: {
      ...barChartBase.xAxis,
      labels: {
        useHTML: true,
        align: 'center',
        // eslint-disable-next-line
        formatter: function() {
          return `<img src=${
            shippedQuantitiesByCarrier[this.pos].carrier.logoUrl
          } style="width: 50px;"></img>`;
        }
      },
      categories: shippedQuantitiesByCarrier
        .slice(0, 100)
        .map(s => s.carrier.name)
    },
    yAxis: {
      stackLabels: {
        enabled: false
      },
      maxPadding: 0.1
    },
    plotOptions: {
      series: {
        dataLabels: {
          inside: false,
          // eslint-disable-next-line
          formatter: function() {
            return `${this.total} | ${(
              (this.total * 100) /
              totalShipped
            ).toFixed(2)} %`;
          }
        }
      }
    },
    series: [
      {
        name: 'Transporteur',
        data: shippedQuantitiesByCarrier.slice(0, 100).map(s => ({
          name: s.carrier.name,
          color: s.carrier.color || '#3D59A8',
          y: s.quantity
        }))
      }
    ]
  };
  const options = merge(cloneDeep(barChartBase), override);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Box pt={6} pl={10} pr={10}>
        <Box display="flex" alignItems="baseline" mb={4}>
          <Box fontSize={21} color="#001C56">
            Colis expédiés
          </Box>
        </Box>
      </Box>
      {loadingShippedQuantitiesByCarrier ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}

      <Divider />
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  shippedQuantitiesByCarrier: state.dashboard.shippedQuantitiesByCarrier,
  loadingShippedQuantitiesByCarrier:
    state.dashboard.loadingShippedQuantitiesByCarrier
});

ShippedItemsPackageDialog.propTypes = {
  shippedQuantitiesByCarrier: PropTypes.array,
  open: PropTypes.bool,
  loadingShippedQuantitiesByCarrier: PropTypes.bool,
  handleClose: PropTypes.func
};

export default connect(mapStateToProps)(ShippedItemsPackageDialog);
